import { useCallback, useRef, useState } from 'react'

/** Screen-shake trigger. Apply `shaking && 'animate-shake'` to a container and
 *  call shake() on a hit. Re-triggerable mid-animation via a key bump. */
export function useScreenShake(durationMs = 400): { shaking: boolean; key: number; shake: () => void } {
  const [shaking, setShaking] = useState(false)
  const [key, setKey] = useState(0)
  const timer = useRef<number | null>(null)
  const shake = useCallback(() => {
    setKey((k) => k + 1)
    setShaking(true)
    if (timer.current) window.clearTimeout(timer.current)
    timer.current = window.setTimeout(() => setShaking(false), durationMs)
  }, [durationMs])
  return { shaking, key, shake }
}
